import { AboutHomePage } from './home/abouthome';
import { VersionUpdatePage } from "./version/updateversion";
import { ModifyPasswordPage } from "./password/modifypwd";
import { BindPhonePage } from "./bind/bindphone";
import { SubmitPhonePage } from "./bind/submitphone";
import { SkinPage } from "./skin/skin";
import { JpushPage } from "./jpush/jpush";
import { AccountPage } from "./account/account";
import { BookborrowPage } from './bookborrow/bookborrow';
import { OnecardPage } from './onecard/onecard';
import { SettingPage } from './setting/setting';
import { SetGesturePage } from './setgesture/setgesture'
 
export const ABOUT_INDEX = [
    AboutHomePage,
    VersionUpdatePage,
    ModifyPasswordPage,
    BindPhonePage,
    SubmitPhonePage,
    SkinPage,
    JpushPage,
    AccountPage,
    BookborrowPage,
    OnecardPage,
    SettingPage,
    SetGesturePage
];



// WEBPACK FOOTER //
// ./src/pages/about/index.ts